export const blogCategoryPathLookup: Record<string, string> = {
  '70745116': '/blog/',
  '69795878': '/blog/nutrition/',
  '69795880': '/blog/training/',
  '69795882': '/blog/journeys/',
  '69795884': '/blog/wellbeing/',
  '69795885': '/blog/news/',
};
